import React from 'react';
import Switch from '@material-ui/core/Switch';
import DateFnsUtils from '@date-io/moment';

import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
  } from '@material-ui/pickers';


export default function ({ scheduleChecked, scheduledDate, scheduledTime, scheduleError, onClickCheckBox, onChangeField  }) {
	return (
		<div style={{ marginTop: '10px' }}>
			<label htmlFor="scheduleToggle"style={{ display: 'block', color: '#BBBBBB' }}>
				Agendar
			</label>
			<div style={{ display: 'flex', alignItems: 'center'}}>
				<Switch
					checked={scheduleChecked}
					onChange={() => onClickCheckBox('scheduleChecked')}
					color="primary"
					name="scheduleToggle"
					inputProps={{ 'aria-label': 'primary checkbox' }}
					style={{ width: 'auto' }}
				/>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDatePicker
						clearable
						label="Data"
						value={scheduledDate}
						onChange={value => onChangeField('scheduledDate', value)}
						format="D/MM/YYYY"
						style={{ marginLeft: '10px' }}
						disabled={!scheduleChecked}
						KeyboardButtonProps={{
							'aria-label': 'escolha a data',
						}}
					/>
					<KeyboardTimePicker
						clearable
						label="Hora"
						value={scheduledTime}
						onChange={value => onChangeField('scheduledTime', value)}
						disabled={!scheduleChecked}
						style={{ marginLeft: '10px' }}
						ampm={false}
					/>
				</MuiPickersUtilsProvider>
			</div>
			{scheduleError !== '' && <span style={{ color: 'red' }}>{scheduleError}</span>}
		</div>
	);
}



























// WEBPACK FOOTER //
// ./src/components/notification/fields/ScheduleNotificationField.js